export { getDocument } from './getDocument';
